<template>
  <div
    :class="{
      'scrolling-logo-band w-full': true,
    }"
  >
    <h4
      :class="{
        'mb-9 text-center text-2xl font-black text-www-color-neutral-medium-dark': true,
      }"
    >
      {{ data?.title }}
    </h4>

    <div
      :class="{
        'ticker flex w-full flex-nowrap overflow-hidden': true,
      }"
    >
      <div
        :class="{
          'ticker-image-container flex w-max flex-shrink-0 items-center justify-center gap-4 will-change-transform lg:w-full': true,
        }"
      >
        <ScrollLogo
          v-for="(logo, index) in logos"
          :key="index"
          v-bind="logo"
          :index="index"
          :is-visible="isVisible"
        />
      </div>
      <div
        :class="{
          'ticker-image-container flex w-max flex-shrink-0 items-center justify-center gap-4 will-change-transform lg:w-full': true,
        }"
      >
        <ScrollLogo
          v-for="(logo, index) in logos"
          :key="index"
          v-bind="logo"
          :index="index"
          :is-visible="isVisible"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ScrollLogo from './ScrollLogo.vue';
import type { ScrollingLogoBandRefQueryResult } from '~/sanity/types';

interface Props {
  data: ScrollingLogoBandRefQueryResult;
  isVisible: boolean;
}

const props = defineProps<Props>();

const logos = props.data?.logos?.logos ?? [];
</script>

<style scoped>
.ticker-image-container {
  animation: tickerAnimation 40s linear infinite;
}

.ticker:hover .ticker-image-container {
  animation-play-state: paused;
}

@keyframes tickerAnimation {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
